<template>
    <div class="jd_home2">
        <div class="home_header">
            <Swipe
                :loop="false"
                :show-indicators="false"
                width="100%"
                height="100%"
                :touchable="false"
                ref="swipeItem"
            >
                <SwipeItem v-for="(item,index) in tabs" :key="index">
                <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
                    <template v-slot:loading>
                    <loading type="spinner" size="20" />
                    </template>
                    <template v-slot:error>加载失败</template>
                </VanImage>
                </SwipeItem>
            </Swipe>
        </div>
        <div class="home_body" :class="ishomebody?'home_bodybk':'' ">
            <div class="tabs">
                <div v-for="(item,index) in tabs" :key="item.id" class="tabcard" :class="{active:index===swiperIndex}" @click="switchTab(item.id,index)">
                    <img :src="index===swiperIndex?item.active:item.noactive" alt="">
                </div>
            </div>
            <SportItem  
                :item="currentItem"
                :sports_id="sportid"
                :detail="detail"
            ></SportItem>   
        </div>

        <!-- <div class="fl" @click="goqus">
            <img src="https://oss.mcloud.moveclub.cn/2025/draw/draw.png"/>
        </div>  -->
    </div>
</template>

<script>
import "./index.less"
import SportItem from "./item";
import { Image, Loading, Tab, Tabs, Swipe, SwipeItem } from "vant";
export default {
    components: {
        VanImage: Image,
        Loading,
        Tab,
        Tabs,
        Swipe,
        SwipeItem,
        SportItem
    },
    watch: {
        item_id(e) {
            this.itemChange();
        },
    },
    data() {
        return {
            currentItem: "",
            tabs: [],
            sportid: this.$route.params.sports_id,
            swiperIndex: 0,
            detail: {},
            item_id: this.$route.params.item_id,    
            ishomebody: true,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
            
        });
    },
    methods: {  
        goqus() {
            this.$router.push({ name: 'luckdraw', params: { acid: 1353 }})
        }, 
        switchTab: function (id,index) {
            console.log(id,index,'123456456')
            this.swiperIndex = index;
            this.currentItem = this.tabs[index];
            this.$router.replace({params: {item_id: id}})
            this.$refs.swipeItem.swipeTo(index);
            if (this.currentItem.id == 498) {
                this.ishomebody = true;
            }
            if (this.currentItem.id == 497) {
                this.ishomebody = false;
            }
        },
        itemChange: function () {
            if(this.cf.isEmpty(this.item_id)){
                this.item_id = this.tabs[0]['id']
                this.$router.replace({params:{item_id: this.tabs[0]['id']}})
                return ;
            }
            this.currentItem = this.tabs.filter((item) => {
                return +item.id === +this.item_id;
            })[0];
            this.swiperIndex = this.tabs.findIndex(item=>+item.id === +this.item_id)
        },
        init() {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
                duration: 0, // 持续展示 toast
            });
            this.$api.sports.sportsMain(this.sportid).then(
                (res) => {
                    res.data.items.forEach((item,index)=>{
                        let arr = JSON.parse(item.content)
                        item.active = arr[0]
                        item.noactive = arr[1]
                    })
                    this.tabs = res.data.items;
                    let {
                        bgstyle,
                        id,
                        tabstyle,
                        introstyle,
                        shareconfig,
                        title,
                    } = res.data;
                    try {
                        bgstyle = JSON.parse(bgstyle);
                        tabstyle = JSON.parse(tabstyle);
                        introstyle = JSON.parse(introstyle);
                        // shareconfig = JSON.parse(shareconfig);
                    } catch (e) {
                        console.error(e);
                    }
                    this.detail = { id, bgstyle, tabstyle, introstyle, title };
                    //定义 颜色
                    this.$storage.set("shareInfo", shareconfig);
                    this.itemChange();
                    this.$refs.swipeItem.swipeTo(this.swiperIndex);
                    if (window.__wxjs_is_wkwebview) {
                        //部分ios
                        window.scrollTo(0, 1);
                    }
                    this.$toast.clear();
                },
                (e) => {
                    this.$toast.clear();
                }
            );
        }
    }
}
</script>
